// SAP Invoices Dashboard removed — stub to prevent downstream breakage
export default {
  namespaced: true,
  state: () => ({
    summary: null,
    timeSeries: [],
    statusBreakdown: null,
    recent: [],
    attemptsByInvoice: {},
    retryStats: null,
    topErrors: [],
    loading: false,
    error: null,
  }),
  getters: {},
  mutations: {},
  actions: {},
};